// Global Shoplift Test JS


/*==============================================================================
TEST ID: [CHS-126] [Sitewide] Menu Reduce L2 Spacing [MOB]
PLATFORM: Shoplift
DATE: 06/2026

GOAL:
Inside Mobile menu, Reduce marging spacing between L2 links

KEY INSIGHT:
N/A

BEHAVIOR:
- [MANUAL TRIGGER] runs only when mobile menu is openned
- Inserts CSS <style> into the page's HTML
==============================================================================*/
// Initialize test
async function initTestCHS_126() {
    
    // Configuration
    const TEST_ID = 'CHS126';
    const HYPOTHESIS_ID = '019e5065-73b5-73ae-88a3-9cf8fc430bb7';
    let variantResult = null;

    // Prevent multiple executions
    if (window.__CHS126_HAS_RUN === true) {
        return;
    }

    // Find mobile menu drawer (<details>)
    var drawerDetails = document.getElementById('Details-menu-drawer-container');

    if (!drawerDetails) {
        return;
    }

    // Function to run test AFTER menu opens
    async function handleMenuOpen() {

        // Prevent multiple executions
        if (window.__CHS126_HAS_RUN === true) {
            return;
        }

        window.__CHS126_HAS_RUN = true;

        try {
            // :white_check_mark: Assignment happens ONLY after user opens menu
            variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

            if (variantResult) {

                // Create or reuse the canonical style CSS (append-safe)
                const STYLE_ID = `${TEST_ID}-CSS`;
                let style = document.getElementById(STYLE_ID);

                if (!style) {
                    style = document.createElement('style');
                    style.id = STYLE_ID;
                    document.head.appendChild(style);
                }

                // Append CSS rules (does NOT overwrite existing ones)
                // TEST - Show Variant
                
                style.appendChild(
                    document.createTextNode(`
                    /* ${STYLE_ID} - Nav Category L2 Spacing Reduction */

.menu-drawer__menu--grandchildlist li {
    margin-bottom: 17px;
}
                    `)
                );

                console.log(`Showing ${TEST_ID} Variant (Triggered on Menu Open)`);

            } else {
                // Show control
                // NO CHANGES DO NOTHING
                console.log(`Showing ${TEST_ID} Control (Triggered on Menu Open)`);
            }

        } catch (error) {
            // Always fail gracefully - show control experience on error
            console.error(`Shoplift test ${TEST_ID} failed:`, error);
        }
    }

    // If menu already open (edge case)
    if (drawerDetails.hasAttribute('open')) {
        handleMenuOpen();
        return;
    }

    // Observe for menu open (manual trigger)
    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {

            var mutation = mutations[i];

            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {

                if (drawerDetails.hasAttribute('open')) {
                    observer.disconnect();
                    handleMenuOpen();
                    return;
                }
            }
        }
    });

    observer.observe(drawerDetails, { attributes: true });
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs = 5000) {
    const start = Date.now();

    const tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_126));
} else {
    whenShopliftReady(initTestCHS_126);
}



////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////